// extracted by mini-css-extract-plugin
module.exports = {"label":"gyRrGkOe","labelSubtext":"_2rkJYU-C","labelSubtextTo":"DKmbuFo9","basicInfoRowInputSelects":"_18Ln0EG9","inputSelectsRow":"_9Cfn1F_V","inputCheckbox":"_1oGNB3c0","presentLabel":"_24kpFvSD"};
    if(module.hot) {
      // 1754514949800
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  